"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const styled_1 = __importDefault(require("../utils/styled"));
const Container = styled_1.default("div") `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.space.small}px;
  color: ${({ onClick, theme }) => (Boolean(onClick) ? theme.color.primary : "inherit")};
  cursor: ${({ onClick }) => (Boolean(onClick) ? "pointer" : "initial")};
  border: 1px solid ${({ theme }) => theme.color.border.disabled};
`;
exports.DataTableFooter = props => React.createElement(Container, Object.assign({}, props));
exports.default = exports.DataTableFooter;
//# sourceMappingURL=DataTableFooter.js.map